module.exports = __webpack_public_path__ + "img/u1196.aceb4b4b.svg";